import { Route, Switch } from 'react-router-dom';

import { getNoAuthRoutes } from '../../routes/noAuthConfig';

const NoAuth = () => (
  <Switch>
    {getNoAuthRoutes().map(route => (
      <Route key={route.path} path={route.path} exact={route.exact} render={route.render} />
    ))}
  </Switch>
);

export default NoAuth;
